export default __webpack_public_path__ + "static/guardian-bee-608b8ade69c5a1b74f2537b00ff4bc0a.png";